import {date, DetailColumns, DetailPane, FormDialog} from '@management-ui/core';
import {Edit} from '@mui/icons-material';
import React, {useContext, useState} from 'react';
import ConfirmDate from '../../../../components/ConfirmDate';
import {ServiceContext} from '../../../../components/Services';
import Text from '../../../../components/Text';
import YesNo from '../../../../components/YesNo';
import {formatCurrency} from '../../../../utilities';
import PurchaseOrderForm from '../../forms/PurchaseOrderForm';

const Delivery = ({order, onOrderUpdated}) => {
  const services = useContext(ServiceContext);
  const [fields, setFields] = useState('core');
  const [showForm, setShowForm] = useState(false);

  return (
    <>
      <DetailColumns columns={[
        <DetailPane
          title="Collection"
          actions={order.archived || order.locked ? [] : [
            {title: 'Edit', icon: <Edit/>, onClick: () => setFields('collection') || setShowForm(true)},
          ]}
          details={[
            {title: 'Address', value: <Text text={order.collection_address ?? '-'}/>},
            {
              title: 'Proposed Date',
              value: (
                <ConfirmDate
                  order={order}
                  field="collection_date"
                  service={services.purchaseOrder.saveOrder}
                  onUpdated={onOrderUpdated}
                />
              )
            },
          ]}
        />,

        <DetailPane
          title="Delivery"
          actions={order.archived || order.locked ? [] : [
            {title: 'Edit', icon: <Edit/>, onClick: () => setFields('delivery') || setShowForm(true)},
          ]}
          details={[
            {title: 'Address', value: <Text text={order.delivery_address ?? '-'}/>},
            {title: 'Proposed Date', value: order.delivery_date ? date(order.delivery_date) : '-'},
          ]}
        />,

        <DetailPane
          title="Notes"
          actions={order.archived ? [] : [
            {title: 'Edit', icon: <Edit/>, onClick: () => setFields('notes') || setShowForm(true)},
          ]}
          details={[
            {title: 'Notes', value: <Text text={order.notes ?? '-'}/>},
          ]}
        />,
      ]}/>

      <DetailColumns columns={[
        <DetailPane
          title="Transport"
          actions={order.archived || order.locked ? [] : [
            {title: 'Edit', icon: <Edit/>, onClick: () => setFields('transport') || setShowForm(true)},
          ]}
          details={[
            {title: 'Company', value: order.transporter?.name ?? '-'},
            {title: 'Cost', value: order.transport_cost ? formatCurrency(order.transport_cost, order.currency) : '-'},
            {title: 'Booked', value: <YesNo value={order.transport_booked}/>}
          ]}
        />,
      ]}/>

      <FormDialog
        title="Edit Purchase Order"
        open={showForm}
        onClose={() => setShowForm(false)}
        maxWidth="md"
        render={(props) => (
          <PurchaseOrderForm
            {...props}
            order={order}
            fields={fields}
            onSaved={(updated) => setShowForm(false) || onOrderUpdated(updated)}/>
        )}
      />
    </>
  );
}

export default Delivery;
